/* eslint-disable react-native/no-inline-styles */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import i18n from 'i18n-js';

import KeyEvent from 'react-native-keyevent';

import { ElementBox, Element, scaleWeb } from '@components/frame';

import Svg from '@styles/icons/svg';
import TouchableElement from '@components/common/touchableElement';
import { font as initialFont } from '@styles/fonts';

const Coursor = React.memo(({ countSize, count, CC }) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    let s = false;
    let interval = setInterval(() => {
      setShow(s);
      s = !s;
    }, 500);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <View
      style={{
        justifyContent: 'center',
        position: 'absolute',
        height: '100%',
        alignContent: 'center',
        width: '100%',
        textAlign: 'center',
        opacity: 1,
      }}
    >
      <View
        style={{
          justifyContent: 'center',
          opacity: show ? 1 : 0,
          textAlign: 'center',
          alignItems: 'center',
          flexDirection: 'row',
        }}
      >
        <Text
          style={{
            fontSize: scaleWeb(countSize),
            color: 'black',
            textAlign: 'center',
            justifyContent: 'center',
            opacity: 0,
          }}
        >
          {count}
        </Text>
        <View
          style={{
            borderRightColor: CC('Label / Dark / AlwaysLight Primary'),
            borderRightWidth: scaleWeb(1),
            height: '75%',
            marginLeft: scaleWeb(5),
          }}
        />
      </View>
    </View>
  );
});

const Keyboard = (props) => {
  const { done, CC, close, numbers, numberPress, shadow, font = initialFont } = props;
  return [
    <Element
      {...{
        useScaleOP: true,
        config: {
          position: {
            top: -18,
            bottom: -18,
            left: 0,
            right: 0,
          },
        },
      }}
    >
      <Element
        {...{
          useScaleOP: true,
          config: {
            position: {
              right: 0,
              top: 30,
            },
            width: 140,
            height: 48,
          },
        }}
      >
        <TouchableElement onPress={done}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                {
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: scaleWeb(10),
                  backgroundColor: CC(pressHoverColor('Button/Dark/PrimaryMono')),
                },
                boxStyle,
              ]}
            >
              <Text
                style={[
                  {
                    color: CC(pressHoverColor('Label / Dark / AlwaysDark Primary')),
                    // fontSize: scaleWeb(22),
                    letterSpacing: scaleWeb(0.5),
                  },
                  font['Title 2'],
                ]}
              >
                {i18n.t('Done')}
              </Text>
            </View>
          )}
        </TouchableElement>
      </Element>
      <Element
        {...{
          useScaleOP: true,
          config: {
            position: {
              left: 0,
              top: 30,
            },
            width: 140,
            height: 48,
            borderRadius: scaleWeb(10),
          },
        }}
      >
        <TouchableElement onPress={close}>
          {({ boxStyle, pressHoverColor }) => (
            <View style={({ width: '100%', height: '100%', justifyContent: 'center' }, [boxStyle])}>
              <Text
                style={[
                  {
                    color: CC(pressHoverColor('Button/Dark/PrimaryMono')),
                    fontSize: scaleWeb(22),
                    letterSpacing: scaleWeb(0.5),
                  },
                  font['Title 2'],
                ]}
              >
                Cancel
              </Text>
            </View>
          )}
        </TouchableElement>
      </Element>
      <Element
        {...{
          useScaleOP: true,
          config: {
            verticalCenter: 109,
            position: {
              left: 281,
              right: 281,
            },
            height: 412,
          },
        }}
      >
        <ElementBox>
          {numbers.map((item) => (
            <Element
              key={item.key}
              {...{
                useScaleOP: true,
                config: {
                  position: item.position,
                  justifyContent: 'center',
                  alignItems: 'center',
                  ...shadow,
                  elevation: item.key === 'remove' ? 0 : 1,
                  shadowOpacity: item.key === 'remove' ? 0 : 0.5,
                  borderRadius: scaleWeb(10),
                },
              }}
            >
              <TouchableElement onPress={() => numberPress(item.key)}>
                {({ boxStyle, pressHoverColor }) => (
                  <View
                    style={[
                      {
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: scaleWeb(10),
                        backgroundColor: CC(pressHoverColor(item.key === 'remove' ? 'transparent' : 'Button/Dark/PrimaryMono')),
                      },
                      boxStyle,
                    ]}
                  >
                    {item.key === 'remove' ? (
                      <Svg icon="backspace" width={scaleWeb(40)} height={scaleWeb(30)} color="white" key={scaleWeb(40)} />
                    ) : (
                      <Text
                        style={{
                          fontSize: scaleWeb(42),
                          color: CC(pressHoverColor('Label / Dark / AlwaysDark Primary')),
                        }}
                      >
                        {item.key}
                      </Text>
                    )}
                  </View>
                )}
              </TouchableElement>
            </Element>
          ))}
        </ElementBox>
      </Element>
    </Element>,
  ];
};

const Panel = (props) => {
  const {
    CC,
    combineHorizontal,
    combineVertical,
    vertical,
    bgColor,
    count: currentCount,
    setCount: setFinalCount,
    setShowEnterCount,
    font = initialFont,
  } = props;

  const [count, setCount] = useState(currentCount);
  const numberPress = (key) => {
    if (key === 'remove') {
      if (`${count}`.length === 1 || count == 0) {
        setCount(0);
        return;
      }
      setCount(`${count}`.slice(0, -1));
      return;
    }
    if (count == 0) {
      setCount(key);
      return;
    }
    setCount(`${count}${key}`);
  };
  KeyEvent.removeKeyUpListener();

  KeyEvent.onKeyUpListener((keyEvent) => {
    const k = keyEvent.keyCode;
    if (k === 111) {
      close();
      return;
    }
    if (k === 66) {
      done();
      return;
    }
    const keyToValue = {
      7: 0,
      8: 1,
      9: 2,
      10: 3,
      11: 4,
      12: 5,
      13: 6,
      14: 7,
      15: 8,
      16: 9,
      67: 'remove',
    };
    if (keyToValue[k]) {
      numberPress(keyToValue[k]);
    }
  });
  useEffect(() => {
    return () => {
      KeyEvent.removeKeyUpListener();
    };
  }, []);
  const close = () => setShowEnterCount(false);
  const done = () => {
    setFinalCount(Number(count));
    close();
  };
  const numbers = [
    {
      position: { left: '0%', right: '68.03%', top: '0%', bottom: '77.18%' },
      key: 1,
    },
    {
      position: { left: '34.01%', right: '34.01%', top: '0%', bottom: '77.18%' },
      key: 2,
    },
    {
      position: { left: '68.03%', right: '0%', top: '0%', bottom: '77.18%' },
      key: 3,
    },
    {
      position: { left: '0%', right: '68.03%', top: '25.73%', bottom: '51.46%' },
      key: 4,
    },
    {
      position: {
        left: '33.84%',
        right: '34.18%',
        top: '25.73%',
        bottom: '51.46%',
      },
      key: 5,
    },
    {
      position: { left: '68.03%', right: '0%', top: '25.73%', bottom: '51.46%' },
      key: 6,
    },
    {
      position: { left: '0%', right: '68.03%', top: '51.46%', bottom: '25.73%' },
      key: 7,
    },
    {
      position: {
        left: '34.01%',
        right: '34.01%',
        top: '51.46%',
        bottom: '25.73%',
      },
      key: 8,
    },
    {
      position: { left: '68.03%', right: '0%', top: '51.46%', bottom: '25.73%' },
      key: 9,
    },
    {
      position: { left: '34.01%', right: '34.01%', top: '77.18%', bottom: '0%' },
      key: 0,
    },
    {
      position: {
        left: '67.95%',
        right: '0.07%',
        top: '77.18%',
        bottom: '0%',
      },
      key: 'remove',
    },
  ];

  const circleSize = scaleWeb(236);
  const boxWidth = combineVertical(2);

  const countSize = (() => {
    if (`${count}`.length <= 3) {
      return 100;
    } else {
      return (scaleWeb(200) * 1.3) / `${count}`.length;
    }
  })();

  const shadow = {
    shadowColor: '#898A8D',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.5,
    shadowRadius: 0.5,
  };

  return (
    <View style={[styles.setupWrapper, { backgroundColor: bgColor }]}>
      <View style={[styles.setupHeader, { height: combineHorizontal(2) }]}>
        <View style={{ width: vertical }} />
        <View style={[styles.chartBlock, { width: boxWidth }]}>
          <View
            style={[
              styles.circleBlock,
              {
                width: circleSize,
                height: circleSize,
                marginRight: scaleWeb(16.5),
                marginLeft: scaleWeb(16.5),
              },
            ]}
          >
            <View
              style={[
                styles.chartInfo,
                {
                  width: circleSize - scaleWeb(8.5 * 2),
                  height: circleSize - scaleWeb(8.5 * 2),
                  left: scaleWeb(8.5),
                  top: scaleWeb(8.5),
                  borderRadius: (circleSize - scaleWeb(8.5 * 2)) / 2,
                  paddingTop: scaleWeb(42),
                  paddingBottom: scaleWeb(18),
                },
              ]}
            />
            <View
              style={[
                styles.chartInfo,
                {
                  width: circleSize - scaleWeb(8.5 * 2),
                  height: circleSize - scaleWeb(8.5 * 2),
                  left: scaleWeb(8.5),
                  top: scaleWeb(8.5),
                  borderRadius: (circleSize - scaleWeb(8.5 * 2)) / 2,
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                },
              ]}
            >
              <Element
                {...{
                  useScaleOP: true,
                  config: {
                    width: 360,
                    height: 35,
                    horizontalCenter: 0,
                    verticalCenter: -75,
                    parentWidth: circleSize - scaleWeb(8.5 * 2),
                    parentHeight: circleSize - scaleWeb(8.5 * 2),
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                  },
                }}
              >
                <Text
                  style={[
                    {
                      color: CC('Label / Dark / AlwaysLight Primary'),
                      // fontSize: scaleWeb(26),
                      textAlign: 'center',
                      letterSpacing: scaleWeb(0.5),
                    },
                    font['Title 1'],
                  ]}
                >
                  finished quantity
                </Text>
              </Element>
              <Element
                {...{
                  useScaleOP: true,
                  config: {
                    width: 360,
                    height: 40,
                    horizontalCenter: 0,
                    verticalCenter: 79,
                    parentWidth: circleSize - scaleWeb(8.5 * 2),
                    parentHeight: circleSize - scaleWeb(8.5 * 2),
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                  },
                }}
              >
                <Text
                  style={[
                    {
                      color: CC('Label / Dark / AlwaysLight Primary'),
                      opacity: 0.6,
                      fontSize: scaleWeb(17),
                      textAlign: 'center',
                      width: scaleWeb(310),
                    },
                    font.Headline,
                  ]}
                >
                  type the quantity that is finished
                </Text>
                <Text
                  style={[
                    {
                      color: CC('Label / Dark / AlwaysLight Primary'),
                      opacity: 0.6,
                      fontSize: scaleWeb(17),
                      textAlign: 'center',
                      width: scaleWeb(310),
                      marginTop: scaleWeb(-2),
                    },
                    font.Headline,
                  ]}
                >
                  for the selected clamping
                </Text>
              </Element>
              <Element
                {...{
                  useScaleOP: true,
                  config: {
                    horizontalCenter: 0,
                    verticalCenter: 2,
                    parentWidth: circleSize - scaleWeb(8.5 * 2),
                    parentHeight: circleSize - scaleWeb(8.5 * 2),
                    width: 270,
                    height: 104,
                    backgroundColor: CC('Panel / Light / Accent 2'),
                    borderRadius: scaleWeb(10),
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'row',
                  },
                }}
              />
              <View
                style={{
                  width: scaleWeb(200),
                }}
              >
                <Text
                  style={{
                    fontSize: scaleWeb(countSize),
                    color: CC('Label / Dark / AlwaysLight Primary'),
                    fontVariant: ['tabular-nums'],
                    textAlign: 'center',
                    marginTop: scaleWeb(-1),
                  }}
                >
                  {count}
                </Text>
                <Coursor {...{ count, countSize, CC }} />
              </View>
            </View>
          </View>
        </View>
        <View style={{ width: vertical }} />
      </View>
      <Keyboard
        {...{
          done,
          CC,
          close,
          numbers,
          numberPress,
          shadow,
          combineHorizontal,
          font,
        }}
      />
    </View>
  );
};

export default Panel;

const styles = StyleSheet.create({
  setupWrapper: {
    flex: 1,
    justifyContent: 'space-between',
  },
  setupHeader: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  },
  mainPanelBlock: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  chartInfoTile: {
    opacity: 0.6,
    fontWeight: 'normal',
  },
  chartInfo: {
    textAlign: 'center',
    alignItems: 'center',
    position: 'absolute',
    zIndex: -1,
  },
  chartActionWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  chartBlock: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  circleBlock: {
    position: 'relative',
  },
});
